import { Box, Flex } from '@qga/roo-ui/components';

import Button from '@/components/Button';
import Heading from '@/components/Heading';
import Text from '@/components/Text';
import { brandColors } from '@/lib/theme/colors';
import { Divider } from '@/v2/components/ui/Divider';

export interface BestAvailableRateCardProps {
  onSelectPackageOption: () => void;
}

const BestAvailableRateCard = ({
  onSelectPackageOption,
}: BestAvailableRateCardProps) => {
  return (
    <Box
      padding={['16px', null, '24px']}
      borderRadius="md"
      border="1"
      borderColor="border"
      overflow="hidden"
      width="100%"
      bg="background.card"
      boxShadow="elevation8"
    >
      <Heading.h6
        color={brandColors.iron}
        lineHeight={['20px', null, '22px']}
        fontSize={['16px', null, '18px']}
      >
        Best Available Rate
      </Heading.h6>
      <Divider my={'16px'} />
      <Flex
        gap={'16px'}
        flexDirection={['column', null, 'row']}
        justifyContent={[null, null, 'space-between']}
      >
        <Flex flexDirection="column">
          <Text
            bold
            color="text.body"
            fontSize={['xs', null, 'sm']}
            lineHeight={['20px', null, '24px']}
            letterSpacing="0.1px"
          >
            Travel any time
          </Text>
          <Text
            color="text.body"
            fontSize={['xs', null, 'sm']}
            lineHeight={['20px', null, '24px']}
            letterSpacing="0.1px"
          >
            Pick your own fly + stay package and save
          </Text>
        </Flex>
        <Button
          dialogue
          noBorder
          block
          width={['100%', null, '200px']}
          onClick={onSelectPackageOption}
        >
          Select and continue
        </Button>
      </Flex>
    </Box>
  );
};

export default BestAvailableRateCard;
